export default function authHeader() {
    let user_token = localStorage.getItem("user_token");
    if (user_token) {
        return {
            "Authorization": "Bearer " + user_token,
            "Accept": "*/*",
            "Content-Type": "application/json",
        };
    }
}